// extracted by mini-css-extract-plugin
export var actionButton = "_s3-0";
export var actionMenuContainer = "_s3-i";
export var bubble = "_s3-2";
export var bubbleActionMenu = "_s3-j";
export var bubbleContext = "_s3-6";
export var bubbleItems = "_s3-7";
export var customer = "_s3-3";
export var divider = "_s3-8";
export var fileList = "_s3-9";
export var hiddenComment = "_s3-o";
export var infoAbove = "_s3-a";
export var internal = "_s3-4";
export var lightActionButton = "_s3-1";
export var link = "_s3-b";
export var merchant = "_s3-5";
export var message = "_s3-c";
export var profilePicture = "_s3-e";
export var quillToolbarContainer = "_s3-f";
export var senderDate = "_s3-g";
export var senderDateCustomer = "_s3-h";
export var senderName = "_s3-d";
export var time = "_s3-k";
export var uploadedImage = "_s3-l";
export var username = "_s3-m";
export var xsmall = "_s3-n";